import React from 'react';
import ExternalLinkButton from "./ExternalLinkButton";
import { getHelpArticle } from "../infra/utils";
const vendorLink = getHelpArticle('7998834-accountant-access');
const clientLink = getHelpArticle('8095833-accountant-access');
export default function AccountantAccessLearnMoreButton(props) {
  const {
    isVendor
  } = props;
  return /*#__PURE__*/React.createElement(ExternalLinkButton, {
    openInNewTab: true,
    underline: "hover",
    href: isVendor ? vendorLink : clientLink
  }, "Learn more about Accountant Access");
}